module.exports = __webpack_public_path__ + "static/media/strikethrough.913a7983.svg";